<template>
  <div class="row" style="
      background: url('/img/bg-1.png') no-repeat left;
      background-size: contain;
      height: 100vh;
      overflow: auto;
    ">
    <div class="col-lg-12">
      <modal :show.sync="modals.successModal">
        <div class="modal-header" style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #15cf79;
          ">
          <div class="col-lg"></div>
          <div class="col-lg-5">
            <div style="
                padding: 15px;
                background-color: transparent;
                border-radius: 100px;
                border: 10px solid white;
              ">
              <i style="color: white; font-size: 90px; font-weight: 900" class="tim-icons icon-check-2"></i>
            </div>
            <div>
              <p style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                ">
                Successful
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="col-lg-12 text-center">
          <p style="
              margin-top: 50px;
              font-size: 40px;
              font-weight: 500;
              color: #606060;
            ">
            Congratulations!
          </p>

          <p style="color: A8A8A8">
            Your account has been successfully created
          </p>

          <div style="display: flex">
            <p style="color: #a8a8a8">Please allow</p>
            &nbsp;
            <p style="font-weight: 600; color: #707070">3 working days</p>
            &nbsp;
            <p style="color: #a8a8a8">for your registration approval</p>
          </div>

          <p style="color: #a8a8a8; margin-top: 20px">
            Click 'Continue' to proceed to login page
          </p>
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <base-button type="primary" v-on:click="getLogin()">Continue</base-button>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.failedModal">
        <div class="modal-header" style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #ea2127;
            text-align: center;
          ">
          <!-- <div class="col-lg"></div> -->
          <div class="col-lg-12">
            <div>
              <i style="color: white; font-size: 120px; font-weight: 900" class="tim-icons icon-alert-circle-exc"></i>
            </div>
            <div>
              <p style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                ">
                Failed
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="col-lg-12 text-center">
          <p style="
              margin-top: 50px;
              font-size: 40px;
              font-weight: 500;
              color: #606060;
            ">
            Warning!
          </p>

          <p style="color: #a8a8a8">Please fill in all the details.</p>

          <p style="color: #a8a8a8; margin-top: 20px">
            Click 'Retry' to go back.
          </p>
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <base-button type="danger" v-on:click="getLogin()">Exit</base-button>&nbsp;
            <base-button type="primary" v-on:click="closeFailedModal()">Retry</base-button>
          </div>
        </div>
      </modal>
      <div class="full-page">
        <!-- <div class="full-page" :class="pageClass"> -->
        <div class="content">
          <div class="row">
            <div style="margin-top: -70px" class="col-lg-12 text-center">
              <p style="font-size: 29px; color: #358CCB">Sign Up</p>
            </div>
          </div>
          <div class="row">
            <div style="margin-top: -30px; margin-bottom: 50px" class="col-lg-12 text-center">
              <p style="font-size: 18px; color: #b9b9b9">
                Please fill up the information to register
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-3 d-flex">
              <card class="card-eprf">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  BASIC DETAILS
                </p>
                <p style="color: #A5A5A5; opacity: 0.7">
                  Company Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyname" :class="{ 'custom-input': true }" />
                </div>
                <p style="color: #A5A5A5; font-size: 10px; margin-top: -1px">
                  {{ this.company_unique }}
                </p>

                <p style="color: #A5A5A5; opacity: 0.7">
                  DOE / Company Registration No.
                  <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="doeno" :class="{ 'custom-input': true }" />
                </div>
                <p style="color: #A5A5A5; font-size: 10px; margin-top: -1px">
                  {{ doeno_unique }}
                </p>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Company Address <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyaddress" :class="{ 'custom-input': true }" />
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Phone No. <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="phoneno" :class="{ 'custom-input': true }" />
                  <p v-if="isphoneno" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">Fax No.</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="faxno" :class="{ 'custom-input': true }" />
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Supporting Document (i.e SSM, Form 29, etc)
                </p>
                <div class="fileinput">
                  <label style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label>
                  <div class="d-flex justify-content-center spinner" v-if="this.uploadload == true">
                    <circle-8></circle-8>
                  </div>

                  <input accept="application/pdf" id="file-upload" type="file" ref="file" name="..." class="valid"
                    :multiple="true" aria-invalid="false" style="display: none" v-on:change="onFileChange" />
                </div>
                <!-- <p>uploading...</p> -->
                <div v-if="this.uploadload == false" style="
                    height: 50px;
                    padding: 0px 20px 20px 0px;
                    margin: 0px 30px 20px 0px;
                  " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                  <div v-for="(file, index) in allfilename" :key="index" class="row">
                    <div class="col-lg-8">
                      <p style="padding-left: 15px; color: #A5A5A5; opacity: 0.7" v-if="selectedFileName"
                        id="file-name">
                        {{ allfilename[index] }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <base-button v-if="selectedFileName" class="btn-sm btn-cancel" style="font-size: 12px"
                        @click="removeFile(index)">
                        Remove
                      </base-button>
                    </div>
                  </div>

                  <div v-for="(file, index) in support_doc_list" :key="index" class="row">
                    <div class="col-lg-8">
                      <p style="padding-left: 15px; color: #A5A5A5; opacity: 0.7" id="file-name">
                        {{ support_doc_list[index] }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <base-button class="btn-sm btn-cancel" style="font-size: 12px" @click="removeFile2(index)">
                        Remove
                      </base-button>
                    </div>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-lg-3 d-flex">
              <card class="card-eprf">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  PIC DETAILS - 1
                </p>
                <p style="color: #A5A5A5; opacity: 0.7">
                  User name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="fullname" :class="{ 'custom-input': true }" />
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Password <span style="color: #EC1B23">*</span>
                </p>
                <div class="col-lg-12">
                  <div class="row">
                    <input class="col-lg" v-if="showPassword1" type="text" v-model="password"
                      :class="{ 'custom-input': true }" />
                    <input class="col-lg" v-else type="password" v-model="password" @focus="short = true"
                      :class="{ 'custom-input': true }" />
                    <button class="custom-button" @click="toggleShow1">
                      <span class="icon is-small is-right">
                        <i class="fas" :class="{
        'fa-eye-slash': showPassword1,
        'fa-eye': !showPassword1,
      }"></i>
                      </span>
                    </button>
                    <el-tooltip class="col-lg-1" effect="light" :open-delay="300" placement="top">
                      <template v-slot:content>
                        <div style="display: flex">
                          <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                            <i v-if="!alphanumeric" class="fas fa-times-circle red-circle"></i>
                            <i v-if="alphanumeric" class="fas fa-check-circle green-circle"></i>
                            At least 8 alphanumeric characters
                          </p>
                          &nbsp;&nbsp;
                        </div>
                        <div style="display: flex">
                          <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                            <i v-if="!upperlower" class="fas fa-times-circle red-circle"></i>
                            <i v-if="upperlower" class="fas fa-check-circle green-circle"></i>
                            Must include uppercase and lowercase
                          </p>
                        </div>
                        <div style="display: flex">
                          <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                            <i v-if="!special" class="fas fa-times-circle red-circle"></i>
                            <i v-if="special" class="fas fa-check-circle green-circle"></i>
                            Must include symbol (e.g. !@#$%^&*)
                          </p>
                        </div>
                      </template>
                      <base-button type="link">
                        <i class="tim-icons icon-alert-circle-exc"></i>
                      </base-button>
                    </el-tooltip>
                  </div>

                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Confirm Password <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px; display: flex">
                  <input v-if="showPassword" type="text" v-model="confirmpassword" @focus="showPasswordMismatch = true"
                    :class="{ 'custom-input': true }" />
                  <input v-else type="password" v-model="confirmpassword" @focus="showPasswordMismatch = true"
                    :class="{ 'custom-input': true }" />
                  <button class="custom-button" @click="toggleShow">
                    <span class="icon is-small is-right">
                      <i class="fas" :class="{
        'fa-eye-slash': showPassword,
        'fa-eye': !showPassword,
      }"></i>
                    </span>
                  </button>
                </div>
                <div style="display: flex; height: 30px">
                  <!-- <p
                    style="
                      font-style: italic;
                      font-size: 12px;
                      color: #5a5a5a;
                      opacity: 0.5;
                    "
                  >
                    Minimum 8 characters
                  </p>
                  &nbsp;&nbsp; -->
                  <p v-if="showPasswordMismatch && confirmpassword !== password"
                    style="font-size: 11px; color: #ea2127">
                    {{ message }}
                  </p>
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Phone No. <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="phoneno1" :class="{ 'custom-input': true }" />
                  <p v-if="isphoneno1" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">Fax No.</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="faxno1" :class="{ 'custom-input': true }" />
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Email <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="email" :class="{ 'custom-input': true }" />
                </div>
                <p style="color: #A5A5A5; font-size: 10px; margin-top: -1px">
                  {{ email_unique }}
                </p>
              </card>
            </div>
            <div v-if="addPIC == 'false'" class="col-lg-3 d-flex">
              <card class="card-eprf">
                <p style="
                    color: #358CCB;
                    font-size: 24px;
                    font-weight: 300;
                    padding: 30px;
                  ">
                  ADD PIC
                </p>
                <div class="w-100 p-4 d-flex align-items-center justify-content-center" style="height: 400px">
                  <div style="
                      padding: 60px;
                      background-color: white;
                      border-radius: 100px;
                      border: 10px solid #358CCB;
                    ">
                    <i style="
                        cursor: pointer;
                        color: #358CCB;
                        font-size: 60px;
                        font-weight: 900;
                      " class="tim-icons icon-simple-add" @click="addCard()"></i>
                  </div>
                </div>
              </card>
            </div>
            <div v-else-if="this.addPIC == 'true'" class="col-lg-3">
              <card style="box-shadow: none; height: 630px; background-color: white">
                <div style="display: flex">
                  <div class="col-lg-9">
                    <p style="
                        color: #358CCB;
                        font-size: 24px;
                        font-weight: 300;
                        padding: 30px 30px 0px 15px;
                        margin-bottom: -1px;
                      ">
                      PIC DETAILS - 2
                    </p>
                  </div>
                  <div class="col-lg"></div>
                  <div>
                    <div style="
                        position: relative;
                        height: 30px;
                        width: 30px;
                        background-color: #ea2127;
                        border-radius: 100px;
                      ">
                      <i style="
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          transform: translate(-50%, -50%);
                          color: white;
                          font-weight: 900;
                          font-size: 15px;
                        " class="tim-icons icon-simple-remove" @click="cancelAddCard()"></i>
                    </div>
                  </div>
                </div>
                <p style="padding-left: 30px; color: #A5A5A5; opacity: 0.7">
                  User name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-left: 30px; padding-right: 30px">
                  <input type="text" v-model="fullname2" :class="{ 'custom-input': true }" />
                </div>

                <p style="
                    padding-left: 30px;

                    color: #A5A5A5;
                    opacity: 0.7;
                  ">
                  Password <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-left: 30px; padding-right: 30px; display: flex">
                  <input v-if="showPassword2" type="text" v-model="password2" :class="{ 'custom-input': true }" />
                  <input v-else type="password" v-model="password2" @focus="short1 = true"
                    :class="{ 'custom-input': true }" />
                  <button class="custom-button" @click="toggleShow2">
                    <span class="icon is-small is-right">
                      <i class="fas" :class="{
        'fa-eye-slash': showPassword2,
        'fa-eye': !showPassword2,
      }"></i>
                    </span>
                  </button>
                </div>

                <div style="padding-left: 360px; display: flex">
                  <el-tooltip effect="light" :open-delay="300" placement="top">
                    <template v-slot:content>
                      <div style="display: flex">
                        <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                          <i v-if="!alphanumeric2" class="fas fa-times-circle red-circle"></i>
                          <i v-if="alphanumeric2" class="fas fa-check-circle green-circle"></i>
                          At least 8 alphanumeric characters
                        </p>
                        &nbsp;&nbsp;
                      </div>
                      <div style="display: flex">
                        <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                          <i v-if="!upperlower2" class="fas fa-times-circle red-circle"></i>
                          <i v-if="upperlower2" class="fas fa-check-circle green-circle"></i>
                          Must include uppercase and lowercase
                        </p>
                      </div>
                      <div style="display: flex">
                        <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                          <i v-if="!special2" class="fas fa-times-circle red-circle"></i>
                          <i v-if="special2" class="fas fa-check-circle green-circle"></i>
                          Must include symbol (e.g. !@#$%^&*)
                        </p>
                      </div>
                    </template>
                    <base-button type="link">
                      <i class="tim-icons icon-alert-circle-exc"></i>
                    </base-button>
                  </el-tooltip>
                </div>

                <!-- <div style="display: flex">
                  <p
                    style="
                      padding-left: 30px;
                      font-style: italic;
                      font-size: 12px;
                      color: #5a5a5a;
                      opacity: 0.5;
                    "
                  >
                    Minimum 8 characters
                  </p>
                  &nbsp;&nbsp;
                  <p
                    v-if="password2.length < 8 && short1"
                    style="font-size: 12px; color: #ea2127"
                  >
                    Not enough characters
                  </p>
                </div> -->

                <p style="
                    display: flex;
                    padding-left: 30px;

                    color: #A5A5A5;
                    opacity: 0.7;
                  ">
                  Confirm Password <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-left: 30px; padding-right: 30px; display: flex">
                  <input v-if="showPassword3" type="text" v-model="confirmpassword2"
                    @focus="showPasswordMismatch = true" :class="{ 'custom-input': true }" />
                  <input v-else type="password" v-model="confirmpassword2" @focus="showPasswordMismatch = true"
                    :class="{ 'custom-input': true }" />
                  <button class="custom-button" @click="toggleShow3">
                    <span class="icon is-small is-right">
                      <i class="fas" :class="{
        'fa-eye-slash': showPassword3,
        'fa-eye': !showPassword3,
      }"></i>
                    </span>
                  </button>
                </div>
                <div style="display: flex; height: 30px">
                  <!-- <p
                    style="
                      padding-left: 30px;
                      font-style: italic;
                      font-size: 12px;
                      color: #5a5a5a;
                      opacity: 0.5;
                    "
                  >
                    Minimum 8 characters
                  </p>
                  &nbsp;&nbsp; -->
                  <p v-if="showPasswordMismatch && confirmpassword2 !== password2
        " style="padding-left: 30px; font-size: 11px; color: #ea2127">
                    {{ message }}
                  </p>
                </div>

                <p style="
                    padding-left: 30px;

                    color: #A5A5A5;
                    opacity: 0.7;
                  ">
                  Phone No. <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-left: 30px; padding-right: 30px">
                  <input type="text" v-model="phoneno2" :class="{ 'custom-input': true }" />
                  <p v-if="isphoneno2" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <p style="
                    padding-left: 30px;

                    color: #A5A5A5;
                    opacity: 0.7;
                  ">
                  Fax No.
                </p>
                <div style="padding-left: 30px; padding-right: 30px">
                  <input type="text" v-model="faxno2" :class="{ 'custom-input': true }" />
                </div>

                <p style="
                    padding-left: 30px;

                    color: #A5A5A5;
                    opacity: 0.7;
                  ">
                  Email <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-left: 30px; padding-right: 30px">
                  <input type="text" v-model="email2" :class="{ 'custom-input': true }" />
                  <p style="color: #A5A5A5; font-size: 10px; margin-top: -1px">
                    {{ email2_unique }}
                  </p>
                </div>
              </card>
            </div>
            <div class="col-lg"></div>
          </div>
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6"></div>
            <div class="col-lg-3 text-right">
              <base-button type="danger" v-on:click="getLogin()">Cancel</base-button>&nbsp;
              <base-button type="primary" :disabled="buttondisabled || cannext"
                v-on:click="handleDone()">Next</base-button>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Alert, Tooltip } from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
// import util from "../../../util/util";
import Card from "../../../components/Cards/Card.vue";
import { Modal, ImageUpload } from "../../../../src/components";
import { debounce } from "src/util/debounce";

export default {
  name: "VendorRegistration",
  components: { [Tooltip.name]: Tooltip, Card, Modal, ImageUpload, Circle8 },

  data() {
    return {
      alphanumeric: false,
      upperlower: false,
      special: false,
      alphanumeric2: false,
      upperlower2: false,
      special2: false,
      company_unique: "",
      doeno_unique: "",
      email_unique: "",
      email2_unique: "",

      selectedFileName: "",
      allfilename: [],
      showPassword: false,
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,

      short: "",
      short1: "",
      showPasswordMismatch: "",

      //data from user
      companyname: "",
      doeno: "",
      companyaddress: "",
      isphoneno: false,
      phoneno: "",
      faxno: "",
      supportdoc: "",

      fullname: "",
      password: "",
      confirmpassword: "",
      isphoneno1: false,
      phoneno1: "",
      faxno1: "",
      email: "",

      fullname2: "",
      password2: "",
      confirmpassword2: "",
      isphoneno2: false,
      phoneno2: "",
      faxno2: "",
      email2: "",

      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      addPIC: "false",

      modals: {
        successModal: false,
        failedModal: false,
      },

      docs: "",
      document: 0,

      documentID: [],

      uploadload: false,
      upload: false,

      buttondisabled: false,
      message: "",

      support_doc: "",
      support_doc_list: [],
    };
  },
  watch: {
    phoneno2() {
      if (this.phoneno2.length <= 7) {
        this.isphoneno2 = true;
      } else {
        this.isphoneno2 = false;
      }
    },
    phoneno1() {
      if (this.phoneno1.length <= 7) {
        this.isphoneno1 = true;
      } else {
        this.isphoneno1 = false;
      }
    },
    phoneno() {
      if (this.phoneno.length <= 7) {
        this.isphoneno = true;
      } else {
        this.isphoneno = false;
      }
    },
    companyname: debounce(function () {
      this.company_unique = "";

      let obj = {
        company_name: this.companyname,
      };

      this.$http
        .post(":10001/api/v1/helper/check-company-name", obj)
        .then((res) => {
          let response = res.message;
          if (!res.error) {
            this.company_unique = response;
            this.buttondisabled = false;
          } else if (res.error) {
            this.company_unique = response.error_message;
            this.buttondisabled = true;
          } else {
            this.company_unique = "";
            this.buttondisabled = false;
          }
        })
        .catch((err) => {
          this.company_unique = 'Company name is required!';
          // err.response.data.message;
        });
      this.company_unique = "";
    }, 500),

    doeno: debounce(function () {
      this.doeno_unique = "";

      let obj = {
        company_reg_num: this.doeno,
      };

      this.$http
        .post(":10001/api/v1/helper/check-company-reg", obj)
        .then((res) => {
          let response = res.message;
          if (!res.error) {
            this.doeno_unique = response;
            this.buttondisabled = false;
          } else if (res.error) {
            this.doeno_unique = response.error_message;
            this.buttondisabled = true;
          } else {
            this.doeno_unique = "";
            this.buttondisabled = false;
          }
        })
        .catch((err) => {
          this.doeno_unique = 'DOE / Company Registration No. is required!';
          // err.response.data.message;
        });
      this.doeno_unique = "";
    }, 500),

    email: debounce(function () {
      this.email_unique = "";

      let obj = {
        user_email: this.email,
      };

      this.$http
        .post(":10001/api/v1/helper/check-user-email", obj)
        .then((res) => {
          let response = res.message;
          if (!res.error) {
            this.email_unique = response;
          } else if (res.error) {
            this.email_unique = response.error_message;
            this.buttondisabled = true;
          } else {
            this.email_unique = "";
          }
        })
        .catch((err) => {
          this.email_unique = 'Email is required!';
          // err.response.data.message;
        });

      this.email_unique = "";
    }, 500),
    email2: debounce(function () {
      this.email2_unique = "";

      let obj = {
        user_email: this.email2,
      };

      this.$http
        .post(":10001/api/v1/helper/check-user-email", obj)
        .then((res) => {
          let response = res.message;
          if (!res.error) {
            this.email2_unique = response;
          } else if (res.error) {
            this.email2_unique = response.error_message;
            this.buttondisabled = true;
          } else {
            this.email2_unique = "";
          }
        })
        .catch((err) => {
          this.email2_unique = 'Email is required!';
          // err.response.data.message;
        });

      this.email2_unique = "";
    }, 500),
    confirmpassword() {
      if (
        this.password != this.confirmpassword &&
        this.confirmpassword.length < 8
      ) {
        this.message = "Password mismatch.";
        this.buttondisabled = true;
      }

      if (
        this.password == this.confirmpassword &&
        this.confirmpassword.length >= 8
      ) {
        this.message = "";
        this.buttondisabled = false;
      }
    },

    password() {
      if (this.password != this.confirmpassword && this.password.length < 8) {
        this.buttondisabled = true;
      }

      if (this.password == this.confirmpassword && this.password.length >= 8) {
        this.buttondisabled = false;
      }
    },

    confirmpassword2() {
      if (
        this.password2 != this.confirmpassword2 &&
        this.confirmpassword2.length < 8
      ) {
        this.message = "Password mismatch.";
        this.buttondisabled = true;
      }

      if (
        this.password2 == this.confirmpassword2 &&
        this.confirmpassword2.length >= 8
      ) {
        this.message = "";
        this.buttondisabled = false;
      }
    },

    password2() {
      if (
        this.password2 != this.confirmpassword2 &&
        this.password2.length < 8
      ) {
        this.buttondisabled = true;
      }

      if (
        this.password2 == this.confirmpassword2 &&
        this.password2.length >= 8
      ) {
        this.buttondisabled = false;
      }
    },

    password(newValue) {
      this.checkPassword(newValue);
    },

    password2(newValue) {
      this.checkPassword2(newValue);
    },
  },
  methods: {
    checkPassword(value) {
      const alphanumericPattern =
        /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      const hasUppercase = /[A-Z]/.test(value);
      const hasLowercase = /[a-z]/.test(value);
      const hasSpecialChar = /[!@#$%^&*]/.test(value);

      if (alphanumericPattern.test(value)) {
        this.alphanumeric = true;
      } else if (!alphanumericPattern.test(value)) {
        this.alphanumeric = false;
      }

      if (hasUppercase && hasLowercase) {
        this.upperlower = true;
      } else if (!hasUppercase || !hasLowercase) {
        this.upperlower = false;
      }

      if (hasSpecialChar) {
        this.special = true;
      } else if (!hasSpecialChar) {
        this.special = false;
      }

      console.log(this.message);
    },

    checkPassword2(value) {
      const alphanumericPattern =
        /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      const hasUppercase = /[A-Z]/.test(value);
      const hasLowercase = /[a-z]/.test(value);
      const hasSpecialChar = /[!@#$%^&*]/.test(value);

      if (alphanumericPattern.test(value)) {
        this.alphanumeric2 = true;
      } else if (!alphanumericPattern.test(value)) {
        this.alphanumeric2 = false;
      }

      if (hasUppercase && hasLowercase) {
        this.upperlower2 = true;
      } else if (!hasUppercase || !hasLowercase) {
        this.upperlower2 = false;
      }

      if (hasSpecialChar) {
        this.special2 = true;
      } else if (!hasSpecialChar) {
        this.special2 = false;
      }

      console.log(this.message);
    },

    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },

    toggleShow2() {
      this.showPassword2 = !this.showPassword2;
    },
    toggleShow3() {
      this.showPassword3 = !this.showPassword3;
    },

    addCard() {
      this.addPIC = "true";
    },
    cancelAddCard() {
      sessionStorage.removeItem("vendor-full-name2");
      sessionStorage.removeItem("vendor-email2");
      sessionStorage.removeItem("vendor-phone-no2");
      sessionStorage.removeItem("vendor-fax-no2");
      sessionStorage.removeItem("vendor-password2");
      sessionStorage.removeItem("vendor-confirm-password2");

      this.fullname2 =
        sessionStorage.getItem("vendor-full-name2") !== null &&
          sessionStorage.getItem("vendor-full-name2") !== "null"
          ? sessionStorage.getItem("vendor-full-name2")
          : "";

      this.password2 =
        sessionStorage.getItem("vendor-password2") !== null &&
          sessionStorage.getItem("vendor-password2") !== "null"
          ? sessionStorage.getItem("vendor-password2")
          : "";

      this.confirmpassword2 =
        sessionStorage.getItem("vendor-confirm-password2") !== null &&
          sessionStorage.getItem("vendor-confirm-password2") !== "null"
          ? sessionStorage.getItem("vendor-confirm-password2")
          : "";

      this.phoneno2 =
        sessionStorage.getItem("vendor-phone-no2") !== null &&
          sessionStorage.getItem("vendor-phone-no2") !== "null"
          ? sessionStorage.getItem("vendor-phone-no2")
          : "";
      this.faxno2 =
        sessionStorage.getItem("vendor-fax-no2") !== null &&
          sessionStorage.getItem("vendor-fax-no2") !== "null"
          ? sessionStorage.getItem("vendor-fax-no2")
          : "";
      this.email2 =
        sessionStorage.getItem("vendor-email2") !== null &&
          sessionStorage.getItem("vendor-email2") !== "null"
          ? sessionStorage.getItem("vendor-email2")
          : "";
      this.addPIC = "false";
    },
    successModal() {
      this.modals.successModal = true;
    },
    failedModal() {
      this.modals.failedModal = true;
    },
    closeFailedModal() {
      this.modals.failedModal = false;
    },
    getLogin() {
      sessionStorage.removeItem("position-id");
      sessionStorage.removeItem("role-id");
      sessionStorage.removeItem("vendor-add-pic");
      sessionStorage.removeItem("vendor-support-doc");
      sessionStorage.removeItem("vendor-support-doc-1");
      sessionStorage.removeItem("vendor-support-doc-2");

      // this.document_ID2 = this.documentID.split(",").map(Number);

      sessionStorage.removeItem("vendor-company-name");
      sessionStorage.removeItem("vendor-company-address");
      sessionStorage.removeItem("vendor-phone-no");
      sessionStorage.removeItem("vendor-fax-no");
      sessionStorage.removeItem("vendor-doe-license");

      sessionStorage.removeItem("vendor-full-name");
      sessionStorage.removeItem("vendor-email");
      sessionStorage.removeItem("vendor-phone-no1");
      sessionStorage.removeItem("vendor-fax-no1");
      sessionStorage.removeItem("vendor-password");
      sessionStorage.removeItem("vendor-confirm-password");

      sessionStorage.removeItem("vendor-full-name2");
      sessionStorage.removeItem("vendor-email2");
      sessionStorage.removeItem("vendor-phone-no2");
      sessionStorage.removeItem("vendor-fax-no2");
      sessionStorage.removeItem("vendor-password2");
      sessionStorage.removeItem("vendor-confirm-password2");

      sessionStorage.removeItem("vendor-facility-index");
      sessionStorage.removeItem("vendor-facility-type-specify");
      sessionStorage.removeItem("vendor-date-expired");
      sessionStorage.removeItem("vendor-waste-index");

      sessionStorage.removeItem("vendor-transporter-name");
      sessionStorage.removeItem("vendor-doe-no");
      sessionStorage.removeItem("vendor-transporter-company-address");
      sessionStorage.removeItem("vendor-transporter-phone-no");
      sessionStorage.removeItem("vendor-transporter-fax-no");

      sessionStorage.removeItem("vendor-vehicle-reg-no");
      sessionStorage.removeItem("vendor-card-vehicle");

      sessionStorage.removeItem("vendor-vehicle-driver-name");
      sessionStorage.removeItem("vendor-vehicle-driver-ic");
      sessionStorage.removeItem("vendor-card-driver");

      this.$router.push("/login");
    },
    handleDone() {
      sessionStorage.setItem("vendor-company-name", this.companyname);
      sessionStorage.setItem("vendor-doe-license", this.doeno);
      sessionStorage.setItem("vendor-company-address", this.companyaddress);
      sessionStorage.setItem("vendor-phone-no", this.phoneno);
      sessionStorage.setItem("vendor-fax-no", this.faxno);

      sessionStorage.setItem("vendor-full-name", this.fullname);
      sessionStorage.setItem("vendor-password", this.password);
      sessionStorage.setItem("vendor-confirm-password", this.confirmpassword);
      sessionStorage.setItem("vendor-phone-no1", this.phoneno1);
      sessionStorage.setItem("vendor-fax-no1", this.faxno1);
      sessionStorage.setItem("vendor-email", this.email);

      sessionStorage.setItem("vendor-full-name2", this.fullname2);
      sessionStorage.setItem("vendor-password2", this.password2);
      sessionStorage.setItem("vendor-confirm-password2", this.confirmpassword2);
      sessionStorage.setItem("vendor-phone-no2", this.phoneno2);
      sessionStorage.setItem("vendor-fax-no2", this.faxno2);
      sessionStorage.setItem("vendor-email2", this.email2);

      sessionStorage.setItem("vendor-add-pic", this.addPIC);

      this.$router.push("/vendor-register-1");
    },
    onFileChange(event) {
      this.upload = true;
      const t = event.target;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          this.selectedFileName = t.files[i].name;
          this.allfilename.push(this.selectedFileName);
        }
        sessionStorage.setItem("vendor-support-doc", this.allfilename);
      } else {
        this.selectedFileName = "";
      }

      this.document = t.files.length;

      var input;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.file.files[i];
          const formData = new FormData();
          formData.append("document", input);
          this.docs = formData;

          this.uploadload = true;
          this.buttondisabled = true;

          this.$http
            .post(":10001/api/v1/upload/company_support_document", this.docs, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                console.log("data masuk", response);
                this.documentID.push(response.document_id);
              } else {
                console.log("data tak masuk");
              }
            });
          this.uploadload = false;
          this.buttondisabled = false;
        }
      }
    },
    removeFile(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
        this.allfilename.splice(indexToRemove, 1);
        this.documentID.splice(indexToRemove, 1);
      }
      this.$emit("change", null);
    },
    removeFile2(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.support_doc_list.length) {
        this.documentID.splice(indexToRemove, 1);
        this.support_doc_list.splice(indexToRemove, 1);
      }
      sessionStorage.setItem("vendor-support-doc", this.support_doc_list);
      this.$emit("change", null);
    },
  },
  created() { },
  computed: {
    cannext() {
      if (this.addPIC == 'false') {
        return this.companyname === '' || this.doeno === '' || this.companyaddress === '' || this.phoneno === '' || this.fullname === '' || this.phoneno1 === '' || this.email === '';
      } else {
        return this.companyname === '' || this.doeno === '' || this.companyaddress === '' || this.phoneno === '' || this.fullname === '' || this.phoneno1 === '' || this.email === '' || this.fullname2 === '' || this.phoneno2 === '' || this.email2 === '';
      }
    },
    checkNo: {
      get() {
        return this.faxno.startsWith("0") || this.faxno.startsWith("+")
          ? this.phoneno
          : this.faxno;
      },
      set(value) {
        if (value.startsWith("0")) {
          this.phoneno = value;
          this.faxno = "";
        } else {
          this.faxno = value;
          this.phoneno = "";
        }
      },
    },
    checkNo1: {
      get() {
        return this.faxno1.startsWith("0") || this.faxno1.startsWith("+")
          ? this.phoneno1
          : this.faxno1;
      },
      set(value) {
        if (value.startsWith("0")) {
          this.phoneno1 = value;
          this.faxno1 = "";
        } else {
          this.faxno1 = value;
          this.phoneno1 = "";
        }
      },
    },
    checkNo2: {
      get() {
        return this.faxno2.startsWith("0") || this.faxno2.startsWith("+")
          ? this.phoneno2
          : this.faxno2;
      },
      set(value) {
        if (value.startsWith("0")) {
          this.phoneno2 = value;
          this.faxno2 = "";
        } else {
          this.faxno2 = value;
          this.phoneno2 = "";
        }
      },
    },
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },

  mounted() {
    this.companyname =
      sessionStorage.getItem("vendor-company-name") !== null &&
        sessionStorage.getItem("vendor-company-name") !== "null"
        ? sessionStorage.getItem("vendor-company-name")
        : "";

    this.doeno =
      sessionStorage.getItem("vendor-doe-license") !== null &&
        sessionStorage.getItem("vendor-doe-license") !== "null"
        ? sessionStorage.getItem("vendor-doe-license")
        : "";

    this.companyaddress =
      sessionStorage.getItem("vendor-company-address") !== null &&
        sessionStorage.getItem("vendor-company-address") !== "null"
        ? sessionStorage.getItem("vendor-company-address")
        : "";

    this.phoneno =
      sessionStorage.getItem("vendor-phone-no") !== null &&
        sessionStorage.getItem("vendor-phone-no") !== "null"
        ? sessionStorage.getItem("vendor-phone-no")
        : "";

    this.faxno =
      sessionStorage.getItem("vendor-fax-no") !== null &&
        sessionStorage.getItem("vendor-fax-no") !== "null"
        ? sessionStorage.getItem("vendor-fax-no")
        : "";

    this.fullname =
      sessionStorage.getItem("vendor-full-name") !== null &&
        sessionStorage.getItem("vendor-full-name") !== "null"
        ? sessionStorage.getItem("vendor-full-name")
        : "";

    this.password =
      sessionStorage.getItem("vendor-password") !== null &&
        sessionStorage.getItem("vendor-password") !== "null"
        ? sessionStorage.getItem("vendor-password")
        : "";

    this.confirmpassword =
      sessionStorage.getItem("vendor-confirm-password") !== null &&
        sessionStorage.getItem("vendor-confirm-password") !== "null"
        ? sessionStorage.getItem("vendor-confirm-password")
        : "";

    this.phoneno1 =
      sessionStorage.getItem("vendor-phone-no1") !== null &&
        sessionStorage.getItem("vendor-phone-no1") !== "null"
        ? sessionStorage.getItem("vendor-phone-no1")
        : "";

    this.faxno1 =
      sessionStorage.getItem("vendor-fax-no1") !== null &&
        sessionStorage.getItem("vendor-fax-no1") !== "null"
        ? sessionStorage.getItem("vendor-fax-no1")
        : "";

    this.email =
      sessionStorage.getItem("vendor-email") !== null &&
        sessionStorage.getItem("vendor-email") !== "null"
        ? sessionStorage.getItem("vendor-email")
        : "";

    this.fullname2 =
      sessionStorage.getItem("vendor-full-name2") !== null &&
        sessionStorage.getItem("vendor-full-name2") !== "null"
        ? sessionStorage.getItem("vendor-full-name2")
        : "";

    this.password2 =
      sessionStorage.getItem("vendor-password2") !== null &&
        sessionStorage.getItem("vendor-password2") !== "null"
        ? sessionStorage.getItem("vendor-password2")
        : "";

    this.confirmpassword2 =
      sessionStorage.getItem("vendor-confirm-password2") !== null &&
        sessionStorage.getItem("vendor-confirm-password2") !== "null"
        ? sessionStorage.getItem("vendor-confirm-password2")
        : "";

    this.phoneno2 =
      sessionStorage.getItem("vendor-phone-no2") !== null &&
        sessionStorage.getItem("vendor-phone-no2") !== "null"
        ? sessionStorage.getItem("vendor-phone-no2")
        : "";
    this.faxno2 =
      sessionStorage.getItem("vendor-fax-no2") !== null &&
        sessionStorage.getItem("vendor-fax-no2") !== "null"
        ? sessionStorage.getItem("vendor-fax-no2")
        : "";
    this.email2 =
      sessionStorage.getItem("vendor-email2") !== null &&
        sessionStorage.getItem("vendor-email2") !== "null"
        ? sessionStorage.getItem("vendor-email2")
        : "";

    this.addPIC =
      sessionStorage.getItem("vendor-add-pic") !== null &&
        sessionStorage.getItem("vendor-add-pic") !== "null"
        ? sessionStorage.getItem("vendor-add-pic")
        : "false";

    // this.support_doc =
    //   sessionStorage.getItem("vendor-support-doc") !== null &&
    //   sessionStorage.getItem("vendor-support-doc") !== "null"
    //     ? sessionStorage.getItem("vendor-support-doc")
    //     : "";

    // this.support_doc = sessionStorage.getItem("vendor-support-doc");
    // this.allfilename = this.support_doc.split(",").map(String);
    // this.support_doc_list = this.allfilename;

    this.support_doc = sessionStorage.getItem("vendor-support-doc");

    if (this.support_doc) {
      this.support_doc_list = this.support_doc.trim().split(",").map(String);
    } else {
      this.support_doc_list = [];
    }

    // this.documentID = sessionStorage.getItem("vendor-support-doc"); //check balik
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

p {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
}

.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.red-circle {
  color: #EC1B23;
  font-size: 12px;
}

.green-circle {
  color: #0BAA00;
  font-size: 12px;
}
</style>
